<div class="upload" #upload [class.over]="over" [class.error]="errorMessage" data-testid="upload-container">
  <input
  data-testid="upload-input"
    (dragover)="$event.preventDefault()"
    (dragenter)="over = true"
    (dragleave)="over = false"
    (drop)="dropFile($event); over = false"
    (change)="dropFile($event)"
    [multiple]="maxFiles === 0 || maxFiles > 1"
    class="input_file"
    type="file"
    [accept]="extensions.join(',')"
  />

  <div class="upload-content" data-testid="upload-content">
    <span>
      <b>Ajouter un document</b>
    </span>
    <app-icon
      phosphorClass="ph-cloud-arrow-up"
      [iconStyle]="Style.fill"
      [size]="Size.large"
      class="upload_icon"
      [color]="style.inputColor"
    ></app-icon>
  </div>

  @if (errorMessage) {
    <span class="error">
      {{ errorMessage }}
    </span>
  }
</div>
